import { createContext, useContext } from "react";

const AppContainerContext = createContext(null);

export const useAppContainer = () => useContext(AppContainerContext);

const { Provider, Consumer } = AppContainerContext;

export { Provider, Consumer };
